/**
 * Shared Admin navigation config, used by both the desktop sidebar (AdminMenu)
 * and the mobile menu (MobileMenu), so both stay in sync.
 * Each item has a 'module' field that maps to the permission module name.
 * Items without a module field are always visible.
 */
export const menuItemsWithSections = [
    {
        name: "Mantenimiento",
        icon: "cogs",
        items: [
            { name: "Asignaturas", icon: "book", to: "/admin/subject", module: "subject" },
            { name: "Competencias", icon: "tasks", to: "/admin/competence", module: "competence" },
            { name: "Documentos", icon: "address card", to: "/admin/document", module: "document" },
            { name: "Documentos institucionales", icon: "file pdf outline", to: "/admin/institutional-documents", module: "institutionalDocument" },
            { name: "Grados", icon: "sort numeric ascending", to: "/admin/grade", module: "grade" },
            { name: "Niveles", icon: "sort alphabet down", to: "/admin/level", module: "level" },
            { name: "Eventos", icon: "calendar", to: "/admin/events", module: "event" },
        ],
    },
    {
        name: "Reportes",
        icon: "file alternate",
        items: [
            { name: "Reportes Administrativos", icon: "file alternate", to: "/admin/report/admin", module: "user" },
            { name: "Reportes Académicos", icon: "file alternate", to: "/admin/report/academic", module: "grade" },
            { name: "Reportes Financieros", icon: "chart line", to: "/admin/reports/financial", module: "paymentCategory" }
        ],
    },
    {
        name: "Caja y Finanzas",
        icon: "money bill alternate outline",
        items: [
            { name: "Control de Caja", icon: "archive", to: "/admin/cash-register", module: "paymentCategory" },
            { name: "Validar Pagos", icon: "check", to: "/admin/payments/validate", module: "paymentCategory" },
        ],
    },
    {
        name: "Usuarios y Permisos",
        icon: "users",
        items: [
            { name: "Usuarios", icon: "user", to: "/admin/users", module: "user" },
            { name: "Tipos de usuario", icon: "vcard", to: "/admin/role", module: "role" },
            { name: "Permisos", icon: "address book outline", to: "/admin/permission", module: "permission" },
        ],
    },
    /* {
        name: "Página Web",
        icon: "world",
        items: [
            { name: "Blog", icon: "dot circle", to: "/admin/blog", module: "blog" },
            { name: "Cursos", icon: "dot circle", to: "/admin/courses", module: "course" },
            { name: "Newsletter", icon: "dot circle", to: "/admin/newsletter", module: "newsletter" },
            { name: "Menu", icon: "dot circle", to: "/admin/menu", module: "menu" },
        ],
    }, */
];

/**
 * Top-level menu items that appear outside the dropdown groups.
 * Each has a module for permission checking.
 * NOTE: module names must match the permission prefixes from backend (e.g., "post" for "post.read")
 */
export const topMenuItems = [
    { name: "Inicio", icon: "home", to: "/admin/dashboard", module: null }, // Always visible
    { name: "Categorías de pago", icon: "money bill alternate outline", to: "/admin/paymentCategory", module: "paymentCategory" },
    { name: "Año académico", icon: "graduation", to: "/admin/academicCycle", module: "academicCycle", pathMatch: ["/admin/academicCycle", /^\/admin\/academicCycle\/\d+\/students$/] },
    { name: "Gestión de asistencias", icon: "calendar check outline", to: "/admin/attendance", module: "attendance" },
    { name: "Foro académico", icon: "users", to: "/admin/forum", module: "post" }, // Backend uses "post" for forum
    { name: "Clases en vivo", icon: "video", to: "/admin/liveClasses", module: "room" }, // Backend uses "room" for live classes
    { name: "Mallas curriculares", icon: "folder open outline", to: "/admin/syllabu", module: "syllabu", pathMatch: ["/admin/syllabu", "/admin/media"] },
    { name: "Notificaciones", icon: "bell outline", to: "/admin/notifications", module: "notification" },
];
